"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentTopics = void 0;
var DocumentTopics;
(function (DocumentTopics) {
    DocumentTopics["GenerationRequested"] = "document.cmd.requested.v1";
    DocumentTopics["ConversionResult"] = "document.fct.conversion-result.v1";
    DocumentTopics["ConversionRequested"] = "document.cmd.conversion-requested.v1";
})(DocumentTopics = exports.DocumentTopics || (exports.DocumentTopics = {}));
//# sourceMappingURL=DocumentCommands.js.map